import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import Page from '../components/ui/Page';
import { Card } from '../components/ui/card';
import { useDataStore } from '../lib/stores/dataStore';
import { Icons } from '../lib/Icons';

export default function ProvisionMapsPage() {
  const students = useDataStore((s) => s.students);
  const studentsLoading = useDataStore((s) => s.studentsLoading);
  const interventionsByStudent = useDataStore((s) => s.interventionsByStudent);
  const interventionsLoading = useDataStore((s) => s.interventionsLoading);

  const eligible = useMemo(() => {
    if (!students || students.length === 0) return [];
    return students.filter((s) => (interventionsByStudent[s.id]?.length || 0) > 0);
  }, [students, interventionsByStudent]);

  const loading = studentsLoading || interventionsLoading;

  return (
    <AppLayout>
      <Page title="Costed Provision Maps" icon={Icons.ClipboardDocumentList} description="Generate provision maps for students with interventions">
        <Card className="p-6">
          <div className="space-y-4">
            <p className="text-sm text-slate-600">
              Students listed below are currently assigned to at least one intervention and can have a costed provision map generated.
            </p>

            {loading ? (
              <div className="text-slate-500">Loading eligible students…</div>
            ) : eligible.length === 0 ? (
              <div className="text-slate-500">No students are currently assigned to interventions.</div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {eligible.map((s) => (
                  <Link
                    key={s.id}
                    to={`/student/${s.id}?openProvision=1`}
                    className="block rounded-xl border border-slate-200 bg-white p-4 hover:shadow-md transition"
                  >
                    <div className="font-medium text-slate-900">{s.fullName || `${s.firstName || ''} ${s.lastName || ''}`.trim() || 'Unnamed Student'}</div>
                    <div className="mt-1 text-sm text-slate-600">Year: {s.yearGroup || 'Not recorded'}</div>
                    <div className="mt-1 text-sm text-slate-600">Interventions: {interventionsByStudent[s.id]?.length || 0}</div>
                    <div className="mt-3 inline-flex items-center text-indigo-600 text-sm">Open Provision Map →</div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </Card>
      </Page>
    </AppLayout>
  );
}

